// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"d408901b","977":"69fbefb6"}[chunkId] + ".chunk.js";
};